export default class MetaGroup {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        metaGroupRetrieve(id: ${id}) {
          id
          name
          metas {
            id
            name
            obj
            type
            percentage
            meta
            incentive
          }         
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );   
   
    response.data.data.metaGroupRetrieve.compressed = {
      metas: response.data.data.metaGroupRetrieve.metas
    };  

    response.data.data.metaGroupRetrieve.metas = response.data.data.metaGroupRetrieve.metas.map(meta => meta.id); 

    return response.data.data.metaGroupRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        metaGroupList {
          results {
            id
            name
            metas {
              id
              name
              obj
              type
              percentage
              meta
              incentive
            }                     
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    for(var i = 0; i < response.data.data.metaGroupList.results.length; i++)
    {
      response.data.data.metaGroupList.results[i].metaList = response.data.data.metaGroupList.results[i].metas.map(meta => meta.name).join(','); 
    }

    return response.data.data.metaGroupList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteMeta(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteMeta.ok;
  }

}